import { Box, Flex, Grid } from '@chakra-ui/react';
import {
  MultiSelect,
  reactSelectStyles,
  Select,
  Text,
} from '@diamond/shared/ui';
import { statusData } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import {
  useCustomerTypes,
  useDistributionChannel,
} from '@diamond/sol-admin/features/shipto';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import shallow from 'zustand/shallow';

const doAutomationOptions = [
  { label: 'Semua', value: 'all' },
  { label: 'Ya', value: 'true' },
  { label: 'Tidak', value: 'false' },
];

export function ActivitiesSmartSearch() {
  const { setValue, watch } = useFormContext();
  const [
    activityStatus,
    category2,
    selectedCustomerTypes,
    setActivityStatus,
    setSelectedCustomerTypes,
  ] = useAuthStore(
    (s) => [
      s.activityStatus,
      s.category2,
      s.selectedCustomerTypes,
      s.setActivityStatus,
      s.setSelectedCustomerTypes,
    ],
    shallow
  );

  const { options: customerTypeOptions } = useCustomerTypes();
  const { data: distributionChannelValues } = useDistributionChannel();

  const distributionChannelOptions = useMemo(() => {
    return [
      { label: 'Semua Distribution Channel', value: '' },
      ...(distributionChannelValues?.data || []).map((dc) => ({
        label: dc.distribution_channel,
        value: dc.distribution_channel,
      })),
    ];
  }, [distributionChannelValues?.data]);

  const statusOptions = useMemo(() => {
    return category2 === '' || category2 === 'semua'
      ? [{ label: 'Semua Status', value: 'semua' }, ...statusData]
      : category2 === 'processed'
      ? [statusData[2]]
      : [statusData[1]];
  }, [category2]);

  const selectedStatus = useMemo(() => {
    return statusOptions.find((it) => it.value === activityStatus);
  }, [activityStatus, statusOptions]);
  const selectedDc = distributionChannelOptions.find(
    (it) => it.value === watch('distribution_channel')
  );
  const selectedDoAutomation = doAutomationOptions.find(
    (it) => it.value === watch('do_automation')
  );
  return (
    <Box my={6} maxW="full">
      <Grid gridTemplateColumns="auto 1fr" gap={8} alignItems="baseline">
        <Text fontSize="sm" fontWeight="bold" whiteSpace="nowrap">
          Smart Search
        </Text>
        <Flex
          justifyContent="flex-start"
          alignItems="flex-start"
          wrap="wrap"
          gap={2}
        >
          <Select
            id="distribution_channel"
            placeholder="Distribution Channel"
            options={statusOptions}
            value={selectedStatus}
            onChange={(val) => {
              const value = val?.value || '';
              setActivityStatus(value);
              setValue('status', value);
            }}
          />
          <Select
            id="order_status"
            placeholder="Status"
            options={distributionChannelOptions}
            value={selectedDc}
            onChange={(val) => {
              const value = val?.value || '';
              setValue('distribution_channel', value);
            }}
          />
          <Select
            id="do_automation"
            placeholder="DO Otomatis"
            options={doAutomationOptions}
            value={selectedDoAutomation}
            onChange={(val) => {
              const value = val?.value || 'all';
              setValue('do_automation', value);
            }}
          />
          <MultiSelect
            id="customer_types"
            placeholder="Tipe Customer"
            chakraStyles={reactSelectStyles}
            options={customerTypeOptions}
            value={selectedCustomerTypes}
            onChange={(vals) => {
              setSelectedCustomerTypes(vals);
              setValue('customer_types', vals);
            }}
          />
        </Flex>
      </Grid>
    </Box>
  );
}
